import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';
import RoutePath from './decor/RoutePath';

const { FiBriefcase, FiCheck, FiArrowUpRight, FiPackage } = FiIcons;

const benefits = [
  'Entregas locales por zonas',
  'Mayor comodidad para tus clientes',
  'Sin mantener una flotilla propia',
  'Atención rápida y directa',
  'Preparado para seguimiento futuro'
];

function BusinessSection() {
  return (
    <section className="business section" id="negocios">
      <div className="container business__card">
        <RoutePath className="business__route" reverse />
        <motion.div
          className="business__content"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="eyebrow eyebrow--dark"><SafeIcon icon={FiBriefcase} /> Comercios aliados</span>
          <h2>¿Tienes un negocio? <em>Nosotros hacemos tus entregas.</em></h2>
          <p>
            Restaurantes, farmacias, tiendas, colmados y comercios pueden utilizar
            Muchacho E’ Mandao para realizar sus entregas en Bonao.
          </p>
          <a
            className="button button--dark button--large"
            href={whatsappUrl('Hola, tengo un negocio y quiero trabajar con Muchacho E’ Mandao.')}
            target="_blank"
            rel="noreferrer"
          >
            Quiero trabajar con ustedes <SafeIcon icon={FiArrowUpRight} />
          </a>
        </motion.div>
        <div className="business__visual">
          <span className="business__package"><SafeIcon icon={FiPackage} /></span>
          <div className="business__benefits">
            {benefits.map((benefit) => (
              <span key={benefit}><SafeIcon icon={FiCheck} /> {benefit}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default BusinessSection;